// extracted by mini-css-extract-plugin
export default {"hero":"Header_hero__M6mFb","pageheader":"Header_pageheader__d7Iiq","headshot":"Header_headshot__2Zpwz"};